"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ToolTipData = void 0;
exports.hideTooltips = hideTooltips;
exports.showTooltip = showTooltip;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

var _nicbaseConversion = require("nicbase-conversion");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _noData = _interopRequireDefault(require("./noData.jpg"));

require("./tool-tip-data.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Colon = ': ';
var Blank = ' ';

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user
  };
};

var hiddenStates = ['EVAPORATOR_1_DEFROST'];

var ToolTipData = /*#__PURE__*/function (_PureComponent) {
  _inherits(ToolTipData, _PureComponent);

  var _super = _createSuper(ToolTipData);

  function ToolTipData() {
    _classCallCheck(this, ToolTipData);

    return _super.apply(this, arguments);
  }

  _createClass(ToolTipData, [{
    key: "render",
    value: function render() {
      return ToolTipData.prepareMappedData(this.props.nicData, this.props.user);
    }
  }], [{
    key: "tempRow",
    value: // The table row for temp entries
    function tempRow(index, cellLeft, cellRight) {
      var result = null;

      if (index !== null && cellLeft) {
        result = /*#__PURE__*/_react["default"].createElement("tr", {
          key: index
        }, cellLeft, cellRight);
      }

      return result;
    }
  }, {
    key: "renderIcons",
    value: function renderIcons(params) {
      if (params && _typeof(params) === 'object') {
        var icons = Object.values(params);

        if (icons.length > 0) {
          var retval = /*#__PURE__*/_react["default"].createElement("div", {
            className: "flow-root"
          }, icons.map(function (icon) {
            return icon.icon && icon.description && /*#__PURE__*/_react["default"].createElement("div", {
              className: "left",
              key: icon.description
            }, icon.icon);
          }));

          return retval;
        }
      }

      return null;
    } // The table cell for temp entries

  }, {
    key: "tempCell",
    value: function tempCell() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var temp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var user = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return /*#__PURE__*/_react["default"].createElement("td", {
        className: "map-inner-cell"
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "toolTipData.temperature.shortcut",
        tagName: "span"
      }), key + Colon, /*#__PURE__*/_react["default"].createElement(_nicbaseConversion.FormattedUnit, {
        value: temp,
        from: "degC",
        to: user.temperatureUnit,
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      }), Blank);
    }
  }, {
    key: "processTempEntries",
    value: function processTempEntries(temps, user) {
      var result = null;

      if (_typeof(temps) === 'object' && Object.keys(temps).length !== 0) {
        var mapcells1 = [];
        var mapcells2 = [];
        Object.keys(temps).map(function (key, index) {
          if (index % 2 === 0) {
            mapcells1[mapcells1.length] = ToolTipData.tempCell(key, temps[key], user);
          } else {
            mapcells2[mapcells2.length] = ToolTipData.tempCell(key, temps[key], user);
          }

          return null;
        });
        result = /*#__PURE__*/_react["default"].createElement("table", {
          className: "map-cell"
        }, /*#__PURE__*/_react["default"].createElement("tbody", null, mapcells1.map(function (cell, index) {
          return ToolTipData.tempRow(index, mapcells1[index], mapcells2[index]);
        })));
      }

      return result;
    }
  }, {
    key: "prepareData",
    value: function prepareData(asset, key, isCoupled, user) {
      var line = /*#__PURE__*/_react["default"].createElement("hr", {
        className: "flex items-start h-px w-auto fill-gray-400 bg-white"
      });

      var resTourName = null;

      if (asset.tourName) {
        resTourName = /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex justify-start items-center ml-1 pt-3"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "mr-2 icon-bold"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.RouteHistory, {
          className: "w-5 h-5 fill-primary"
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "mr-2 bold"
        }, asset.tourName));
      }

      var resName = null;

      if (asset.name) {
        resName = /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex justify-start items-center ml-1 pt-3"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "mr-2 icon-bold"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Asset, {
          className: "w-5 h-5 fill-primary"
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "mr-2 bold text-red"
        }, asset.name));
      }

      var resDate = null;

      if (asset.date || asset.timestamp) {
        resDate = /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex justify-start items-center ml-1 pt-3"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "mr-2"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Timestamp, {
          className: "w-5 h-5 fill-primary"
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "mr-2"
        }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
          value: asset.date || asset.timestamp,
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZone: user.timezone
        }))));
      }

      var resAddress = null;

      if (asset.position && Object.keys(asset.position).length !== 0 && (asset.position.street || asset.position.number || asset.position.postalCode || asset.position.city)) {
        resAddress = /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex justify-start items-center ml-1 pt-3"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "mr-2"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Location, {
          className: "w-5 h-5 fill-primary mb-3"
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex-col"
        }, /*#__PURE__*/_react["default"].createElement("div", null, asset.position.street, " ", asset.position.number), /*#__PURE__*/_react["default"].createElement("div", {
          className: "pb-1"
        }, asset.position.postalCode, " ", asset.position.city)));
      }

      var resTemp = null;

      if (asset.temperatures && Object.keys(asset.temperatures).length !== 0) {
        resTemp = /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex flex-nowrap justify-start items-center ml-1 py-2"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "mr-1 ml-1 items-start"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.TempGroup, {
          className: "w-5 h-5 fill-primary"
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex-none mr-1 mb-2"
        }, ToolTipData.processTempEntries(asset.temperatures, user)));
      }

      var resSetpoint = null;

      if (asset.setpoint1) {
        resSetpoint = /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex justify-start items-center ml-1 py-2"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "mr-2 ml-6 pl-1"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "toolTipData.setpoint.shortcut",
          tagName: "span"
        }), Colon, /*#__PURE__*/_react["default"].createElement(_nicbaseConversion.FormattedUnit, {
          value: asset.setpoint1,
          from: "degC",
          to: user.temperatureUnit,
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        }), Blank));
      }

      var resReeferReturn = null;

      if (asset.reeferReturn1) {
        resReeferReturn = /*#__PURE__*/_react["default"].createElement("div", {
          className: "flow-root"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "left padding-left padding-top-4"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "toolTipData.reeferReturn.shortcut",
          tagName: "span"
        }), Colon, /*#__PURE__*/_react["default"].createElement(_nicbaseConversion.FormattedUnit, {
          value: asset.reeferReturn1,
          from: "degC",
          to: user.temperatureUnit,
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        }), Blank));
      }

      var resSupplyAir = null;

      if (asset.supplyAir1) {
        resSupplyAir = /*#__PURE__*/_react["default"].createElement("div", {
          className: "flow-root"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "left padding-left padding-top-4"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "toolTipData.supplyAir.shortcut",
          tagName: "span"
        }), Colon, /*#__PURE__*/_react["default"].createElement(_nicbaseConversion.FormattedUnit, {
          value: asset.supplyAir1,
          from: "degC",
          to: user.temperatureUnit,
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        }), Blank));
      }

      var resDriverId = null;

      if (asset.driverId) {
        resDriverId = /*#__PURE__*/_react["default"].createElement("div", {
          className: "pt-4 ml-px"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "toolTipData.driverId",
          tagName: "span"
        }), Colon + asset.driverId);
      }

      var resIgnition = null;

      if (asset.ignition) {
        resIgnition = /*#__PURE__*/_react["default"].createElement("div", {
          className: "pt-4 ml-px"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "toolTipData.ignition",
          tagName: "span"
        }), Colon + asset.ignition);
      }

      var resSpeed = null;

      if (asset.speed !== null && asset.speed !== undefined && isCoupled === 'false') {
        resSpeed = /*#__PURE__*/_react["default"].createElement("div", {
          className: "py-2 ml-px"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "toolTipData.speed",
          tagName: "span"
        }), Colon, /*#__PURE__*/_react["default"].createElement(_nicbaseConversion.FormattedUnit, {
          value: asset.speed,
          from: "kmh",
          to: user.lengthUnit,
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        }), Blank);
      }

      var resMileage = null;

      if (asset.mileage) {
        resMileage = /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex justify-start items-center py-2"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "mr-2 ml-px"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Mileage, {
          className: "w-5 h-5 fill-primary"
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "mr-2"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseConversion.FormattedUnit, {
          value: asset.mileage,
          from: "km",
          to: user.lengthUnit,
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
          hideUnit: false
        }), Blank));
      }

      var resLoading = null;

      if (asset.load_condition) {
        resLoading = /*#__PURE__*/_react["default"].createElement("div", {
          className: "flow-root"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "left"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Loading, {
          className: "label-icon"
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "left padding-top-4"
        }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedNumber, {
          value: asset.load_condition / 1000,
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        })), Blank, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "toolTipData.loading.shortcut",
          tagName: "span"
        })));
      }

      var resStates = null;

      if (asset.status && (asset.status.length > 0 || Object.keys(asset.status).length > 0)) {
        var status = asset.status.filter(function (state) {
          return !hiddenStates.includes(state);
        }).map(function (state) {
          var Icon = (0, _mapping.statusToIcon)(state);
          return {
            icon: Icon ? /*#__PURE__*/_react["default"].createElement(Icon, {
              key: state
            }) : null,
            description: state
          };
        });
        resStates = /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex justify-start items-center pt-2"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "mr-1 ml-px"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "toolTipData.state",
          tagName: "span"
        }), Colon), /*#__PURE__*/_react["default"].createElement("div", null, ToolTipData.renderIcons(status)));
      }

      var resAlarms = null;

      if (asset.alarm && (asset.alarm.length > 0 || Object.keys(asset.alarm).length > 0)) {
        var alarms = asset.alarm.map(function (alarm) {
          var Icon = (0, _mapping.reeferErrorCodeToIcon)(alarm.manufacturer, alarm.severity);
          return {
            icon: Icon ? /*#__PURE__*/_react["default"].createElement(Icon, {
              key: "".concat(alarm.manufacturer, ".").concat(alarm.severity)
            }) : null,
            description: "".concat(alarm.manufacturer, ".").concat(alarm.severity)
          };
        });
        resAlarms = /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex justify-start items-center pt-2"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "mr-1 ml-px"
        }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "toolTipData.alarm",
          tagName: "span"
        }), Colon), /*#__PURE__*/_react["default"].createElement("div", null, ToolTipData.renderIcons(alarms)));
      }

      var result = /*#__PURE__*/_react["default"].createElement("div", {
        key: key,
        className: "nic-tooltip-data left"
      }, resTourName, resName, resDate, resAddress, resTemp !== null || resSetpoint !== null || resReeferReturn !== null || resSupplyAir !== null ? line : null, resTemp, resSetpoint, resReeferReturn, resSupplyAir, resDriverId !== null || resIgnition !== null || resSpeed !== null ? line : null, resDriverId, resIgnition, resSpeed, resMileage !== null || resLoading !== null ? line : null, resMileage, resLoading, resStates !== null || resAlarms !== null ? line : null, resStates, resAlarms);

      return result;
    }
  }, {
    key: "prepareMappedData",
    value: function prepareMappedData(data, user) {
      if (!Array.isArray(data) || data.length === 0) {
        return /*#__PURE__*/_react["default"].createElement("img", {
          src: _noData["default"],
          alt: "no Data"
        });
      }

      var dataKeys = Object.keys(data);
      var dataValues = Object.values(data);
      var isCoupled = dataValues.length > 1 ? 'true' : 'false';
      var newData = [];

      for (var i = 0; i < dataKeys.length; i += 1) {
        newData[i] = ToolTipData.prepareData(dataValues[i], dataKeys[i], isCoupled, user);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "flow-root"
      }, newData);
    }
  }]);

  return ToolTipData;
}(_react.PureComponent);

exports.ToolTipData = ToolTipData;
ToolTipData.propTypes = {
  user: _propTypes["default"].shape(),
  nicData: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    date: _propTypes["default"].string,
    position: _propTypes["default"].instanceOf(Object),
    temperatures: _propTypes["default"].instanceOf(Object),
    setpoint1: _propTypes["default"].string,
    reeferReturn1: _propTypes["default"].string,
    supplyAir1: _propTypes["default"].string,
    mileage: _propTypes["default"].number,
    load_condition: _propTypes["default"].number,
    status: _propTypes["default"].instanceOf(Array),
    alarm: _propTypes["default"].instanceOf(Array),
    driverId: _propTypes["default"].string,
    speed: _propTypes["default"].string,
    ignition: _propTypes["default"].string
  }), _propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    date: _propTypes["default"].string,
    position: _propTypes["default"].instanceOf(Object),
    temperatures: _propTypes["default"].instanceOf(Object),
    setpoint1: _propTypes["default"].string,
    reeferReturn1: _propTypes["default"].string,
    supplyAir1: _propTypes["default"].string,
    mileage: _propTypes["default"].number,
    load_condition: _propTypes["default"].number,
    status: _propTypes["default"].instanceOf(Array),
    alarm: _propTypes["default"].instanceOf(Array)
  })]))
};
ToolTipData.defaultProps = {
  nicData: [],
  user: {}
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _nicbaseTranslation.injectIntl)(ToolTipData));

exports["default"] = _default;

function hideTooltips() {
  _reactTooltip["default"].hide();
}

function showTooltip(ref) {
  _reactTooltip["default"].show(ref);
}